import React from 'react';
import DataListAndSearch from '../../components/DataListAndSearch.jsx';
import ProveedorStore from '../../reflux/stores/ProveedorStore';
import ProveedoresActions from '../../reflux/ProveedoresActions';
import AlertActions from '../../reflux/AlertActions';
import Loading from '../../components/Loading.jsx';
import ProveedorForm from '../../components/Forms/ProveedorForm.jsx';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Card from 'material-ui/Card';
import Check from 'material-ui/svg-icons/action/check-circle';
import Delete from 'material-ui/svg-icons/action/delete-forever';

import Search from 'material-ui/svg-icons/action/search';

export default class ProveedoresIndex extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            proveedores: [],
            count: 0,
            editing: false,
            proveedor: null,
            tipos_proveedor: [
                {
                    text: 'Personal Natural Residente',
                    codigo: 'PND',
                    label: function() { return this.text;},
                },
                {
                    text: 'Personal Juridica Domiciliada',
                    codigo: 'PJD',
                    label: function() { return this.text;},
                }
            ]
        };

       	this.handleDelete = this.handleDelete.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onGetProveedores = this.onChangeProveedores.bind(this);
        this.handleSeniatSearch = this.handleSeniatSearch.bind(this);
    }

    componentWillMount() {
        //Get all Proveedores from database
        AlertActions.configureAppBar('Proveedores', null);
        AlertActions.startLoading();
        ProveedoresActions.getProveedores();
    }

    componentDidMount() {
        //Listen to changes in ProveedoresStore
        this.unsubscribe = ProveedorStore.listen(this.onGetProveedores);
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    /**
     * Callback executed when ProveedoresStore Changes
     * 
     * @param {string} e The event that was triggered
     * @param {Array.<Proveedor>} proveedores The proveedores list
     * 
     */
    onChangeProveedores(e, proveedores, count) {
        if(e === 'getProveedores')
            this.setState({proveedores: proveedores, count: count});

        if(e === 'putProveedor') {
            const msg = <div>Proveedor Editado <Check color="green" /></div>;
            AlertActions.alert('open', msg, 'Ha editado satisfactoriamente al proveedor '+proveedores.name+' con el R.I.F. '+proveedores.rif);
            this.setState({editing: false, proveedor: false});
        }

        if(e === 'deletedProveedor') {
            const msg = <div>Proveedor Eliminado  <Delete color="grey" /></div>;
            AlertActions.alert('open', msg, 'Ha eliminado satisfactoriamente al proveedor '+proveedores.name+' con el R.I.F. '+proveedores.rif);
        }
            

        if(e === 'filter')
            this.setState({proveedores: proveedores});
    }

    /**
     * Handle input change when the user is editing a Proveedor
     * 
     * @param Object e The event that was triggered
     */
    handleInputChange(e) {
        let proveedor = this.state.proveedor.handleInputChange(e);
        this.setState({proveedor: proveedor});
    }

    /**
     * Handles the actions of the modal when editing a Proveedor
     * 
     * @param {string} type The actions that was triggered.
     */
    handleProveedorActions(type) {
        switch(type) {
            case 'save':
                ProveedoresActions.putProveedor(this.state.proveedor);
                break;
            case 'cancel':
                this.setState({editing: false, proveedor: null});
                break;
        }
    }

    /**
     * Handles search according to query received from TextField
     * 
     * @param e Event: TextField in which the query is being typed
     */
    handleSearch(q) {
        AlertActions.startLoading();
        ProveedoresActions.apiFilter(q);
    }

    /**
     * Handles clicking on the edit button, show the modal for editing a Proveedor
     * 
     * @param {number} id The id of the Proveedor to be edited
     */
    handleEdit(id) {
        let proveedor = this.state.proveedores[id];
        
        this.setState({
            editing: true,
            proveedor: proveedor
        });
    }

    /**
     * Handles deletion of a record
     * 
     * @param {number} del The index or id of the record to delete from the list
     */
    handleDelete(del) {
        let proveedor = this.state.proveedores[del];

        ProveedoresActions.deleteProveedor(proveedor);
    }

    handleSeniatSearch(rif, e) {
        AlertActions.startLoading();
        ProveedoresActions.getRif(rif);
    }

    render() {
        let LoadMore = 
        this.state.count === this.state.proveedores.length
        ? null
        : (
            <div className="center">
                <RaisedButton
                    onTouchTap={() => {ProveedoresActions.getProveedores(8); AlertActions.startLoading();}} 
                    className="center" 
                    label="Cargar Mas..." 
                    secondary={true} />
            </div>
        );
        //Create ProveedorForm for editing Proveedor
        const form = (
            <ProveedorForm 
                proveedor={this.state.proveedor} 
                handleChange={this.handleInputChange}
                handleSearch={this.handleSeniatSearch}
                tipos_proveedor={this.state.tipos_proveedor} />
        );

        //Create the Actions to be taken on the ProveedorForm
        const actions = (
            <div>
                <FlatButton 
                    label="Guardar" 
                    onTouchTap={this.handleProveedorActions.bind(this, 'save')} />

                <FlatButton 
                    label="Cancelar" 
                    onTouchTap={this.handleProveedorActions.bind(this, 'cancel')} />
            </div>
        );

        return (
            <div className="retivacontainer">
                <DataListAndSearch
                    style={{marginTop:35}}
                    searchTitle="Lista de Proveedores" 
                    onChangeInput={this.handleSearch}
                    inputPlaceHolder={"Buscar Proveedor..."}
                    criterios="nombre o rif del proveedor"
                    items={this.state.proveedores}
                    count={this.state.count}
                    handleEdit={this.handleEdit}
                    handleDelete={this.handleDelete}
                    rightButtonUseThis={false}
                    addButtonLink="/proveedores/create"
                    showAddButton={true}
                    resourceName="proveedor"
                />

                <div className="center" style={{marginBottom:10}}>Mostrando {this.state.proveedores.length} de {this.state.count} proveedores...</div>
                
                {LoadMore}

                <Dialog 
                    title="Editar Proveedor"
                    open={this.state.editing}
                    modal={true}
                    actions={actions}
                    autoDetectWindowHeight={false}
                    autoScrollBodyContent={true}
                    >
                    {form}
                </Dialog>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/pages/Proveedores/ProveedoresIndex.jsx
 **/